import { GROUP_NUMBER_TYPE } from "@visactor/vrender-core";

export class DefaultCanvasGroupPicker {
    constructor() {
        this.type = "group", this.numberType = GROUP_NUMBER_TYPE;
    }
    contains(group, point, params) {
        return !1;
    }
}
//# sourceMappingURL=group-picker.js.map
